export { default } from './InfiniteBanner';
